import { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import EmissionsBySourceSubentity from './EmissionsBySourceSubentity';

const EmissionsBySourceEntity = ({ entity, subentities }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <tr style={{ height: '10px' }}>
        <td colSpan='5' style={{ borderBottom: 'none', padding: 0 }}></td>
      </tr>

      <tr className={`title-row-${entity?.name?.split(' ').join('').replace(':', '-')}`} style={{ textAlign: 'left' }}>
        <td colSpan={5} className='align-middle'>
          <h4 className='relative text-foreground table-title p-[8px] pr-14'>
            {entity.name}
            <span
              onClick={() => setIsExpanded(!isExpanded)}
              className='absolute right-0.5 top-1/2 -translate-y-1/2 cursor-pointer select-none px-3.5 py-2 text-base font-bold'>
              {isExpanded ? '-' : '+'}
            </span>
          </h4>
        </td>
      </tr>

      {isExpanded &&
        subentities?.map((subentity, index) => (
          <EmissionsBySourceSubentity key={index} entity={entity} subentity={subentity} />
        ))}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { data } = state.consumption;

  const { subentities, entities } = state;

  const { entityID } = ownProps;

  const entitySubentities = data?.[entityID] && Object.keys(data[entityID]);

  const entity = _.find(entities, { id: entityID });

  const filteredSub = subentities && subentities.filter(({ id }) => entitySubentities?.includes(String(id)));

  const neededSubentities = subentities && _.orderBy(filteredSub, ['name']);

  return {
    entity,
    subentities: neededSubentities,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsBySourceEntity);
